import { Cookies } from 'react-cookie';

import { UserOnObjectResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface GetObjectUsersParams {
  objectSlug: string;
}

export const getObjectUsers = async ({ objectSlug }: GetObjectUsersParams) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object/${objectSlug}/users/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as UserOnObjectResponse[];
};
